__turbopack_context__.v({
  "headerLine": "PolicyCard-module__5k6Bqq__headerLine",
});
